import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  createMeeting,
  showModal,
  setAttendeeReadinessCheck,
  setUserBackground,
  getBrandingSettings,
  setTransformedVideoInputs,
  getCurrentBroadcast
} from '@shoflo/studio-redux/actions';
import subscribeToRooms from '@shoflo/studio-redux/actions/realtime/subscribeToRooms';
import { dispatchBrandingSettings } from '@shoflo/polymer';
import { NO_AUDIO_INPUT_ERROR } from 'constants/Modal';
import { useHistory } from 'react-router';
import { useParams, useRouteMatch } from 'react-router-dom';
import { StudioLogger } from '@studio/logger/StudioLogger';
import { useCommonPageActionsApi } from '@studio/metrics/client/react/useCommonPageActionsApi';
import { setProgram } from '../../actions/program';

const logger = new StudioLogger('join-meeting');

const useJoinFlow = ({ hostEnters }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { eventId, teamId, broadcastId } = useParams();
  const match = useRouteMatch();
  const broadcast = useSelector(state => state.broadcast);
  const hasAttendeeCheckedReadiness = useSelector(
    state => state.attendeeReadinessCheck?.hasAttendeeCheckedReadiness
  );

  const { startMeetingAsHost, endMeetingAsHost } = useCommonPageActionsApi();
  const isBroadcastLoaded = !!broadcast?._id;

  useEffect(() => {
    if (isBroadcastLoaded) {
      dispatchBrandingSettings(
        broadcast?.settings?.branding,
        dispatch,
        getBrandingSettings
      );
    }
  }, [dispatch, isBroadcastLoaded]);

  useEffect(() => {
    if (hasAttendeeCheckedReadiness) {
      history.push(
        `/studio-director-embed/teams/${teamId}/events/${eventId}/broadcasts/${broadcastId}${window.location.search}`
      );
    }
  }, [hasAttendeeCheckedReadiness]);

  /**
   *
   * @param audioInputDeviceId
   * @param audioOutputDeviceId
   * @param presenterTitle
   * @param presenterDescription
   * @param userBackground
   * @param transformedVideoInputs
   * @param videoInput
   */
  const handleJoinMeeting = ({
    audioInputDeviceId,
    audioOutputDeviceId,
    videoInputDeviceId,
    presenterTitle,
    presenterDescription,
    userBackground,
    transformedVideoInputs,
    videoInput,
    notification
  }) => {
    if (
      !window._DATADOG_SYNTHETICS_BROWSER === true && //isDDSynthetics
      ['', undefined].includes(audioInputDeviceId)
    ) {
      logger.info('User entered studio without an audio device', {});
      dispatch(showModal(NO_AUDIO_INPUT_ERROR));
      return;
    }

    dispatch(subscribeToRooms());
    dispatch(setAttendeeReadinessCheck(true));
    dispatch(setUserBackground(userBackground));
    dispatch(setTransformedVideoInputs(transformedVideoInputs));

    startMeetingAsHost({
      pathName: match.path,
      url: match.url
    });
    dispatch(
      createMeeting(
        {
          audioInputDeviceId,
          audioOutputDeviceId,
          videoInputDeviceId,
          presenterTitle,
          presenterDescription,
          userBackground,
          transformedVideoInputs,
          videoInput,
          notification
        },
        hostEnters,
        endMeetingAsHost,
        setProgram
      )
    );
    dispatch(getCurrentBroadcast());
  };

  return { handleJoinMeeting };
};

export { useJoinFlow };
